import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from '@castinflow/ui';
import { App } from './App';
import { SystemErrorBoundary } from './pages/StatePages';
import { captureAdConnectReturn } from './framework/connections/ad-connect-return';
import { captureGoogleAdsConnectReturn } from './framework/connections/google-ads-connect-return';
import './index.css';

// v3.1 K3: sağlayıcının dönüş adresindeki yetki kodu ve durum değeri, uygulama çizilmeden (ilk API çağrısından) ÖNCE belleğe
// alınır ve adres çubuğundan silinir — oturum denetimi ve kabuk istekleri sorgulu adresle gönderilmez
captureAdConnectReturn();
// v3.2 D: arama reklamları hesabı bağlamanın dönüş adresi de aynı kuralla (ayrı yol, ayrı bellek)
captureGoogleAdsConnectReturn();

// Plan §5: TanStack Query yalnız bellekte; çıkış/tenant değişiminde temizlenir (WP 1.6)
const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 10_000, refetchOnWindowFocus: false } },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root bulunamadı');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <SystemErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ToastProvider>
      </QueryClientProvider>
    </SystemErrorBoundary>
  </React.StrictMode>,
);
